<div class="row">
  <app-user-information class="col-12 col-md-6"></app-user-information>
<!--  <app-supplier-information class="col-12 col-md-6"></app-supplier-information>-->
</div>
